// extracted by mini-css-extract-plugin
module.exports = {"container":"discover-DiscoverLivestreamEventItem__container--3igKB","fullWidth":"discover-DiscoverLivestreamEventItem__fullWidth--2o3i8"};